var app = {
	header: {
		build: "Build",
		closeButton: "Zamknij",
		copyrightLabel: "Copyright",
		helpLabel: "Pomoc",
		legalNoticeLabel: "Stopka redakcyjna",
		logoutButton: "Wyloguj się",
		menuLabel: "Menu",
		module: "Moduł",
		myData: "Moje dane",
		noUserDataLabel: "Brak danych",
		notificationsLabel: "Powiadomienia",
		privacyPolicyLabel: "Ochrona danych",
		search: "Szukaj",
		searchPlaceholder: "Termin lub pytanie do wyszukania",
		serviceAppLabel: "Aplikacja serwisowa",
		settingsLabel: "Ustawienia",
		shopLabel: "Sklep",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Informacje o oprogramowaniu",
		toMytrumpf: "Do MyTRUMPF",
		toTrumpfCom: "Do trumpf.com",
		userLabel: "Profil",
		userProfileLinkText: "Profil",
		version: "Wersja"
	}
};
var contentLoadingError = "Nie można załadować treści";
var dashboard = {
	cancel: {
		button: "Anuluj"
	},
	edit: {
		button: "Edytuj"
	},
	reset: {
		button: "Resetuj"
	},
	save: {
		button: "Zapisz"
	},
	share: {
		button: "Udostępnij"
	}
};
var fileUpload = {
	invalidFileType: "Plik jest niewłaściwego typu",
	maxFileSize: "Plik jest większy niż dozwolone (maks. {{maxSizeInMb}} MB)",
	maxFilesReached: "Osiągnięto maksymalną liczbę plików"
};
var filter = {
	clear: "Zresetuj filtr",
	clearAll: "Zresetuj wszystkie filtry"
};
var general = {
	nextButton: "Dalej",
	prevButton: "Wstecz",
	resetButton: "Resetuj"
};
var locationMap = {
	locationLink: {
		label: "Do lokalizacji"
	}
};
var machineDiscontinuation = {
	linkText: "Dowiedz się więcej"
};
var notifications = {
	button: {
		loadMore: "Załaduj więcej"
	},
	date: {
		lastMonth: "Poprzedni miesiąc",
		lastWeek: "Poprzedni tydzień",
		older: "Starsze",
		thisMonth: "Bieżący miesiąc",
		thisWeek: "Bieżący tydzień",
		today: "Dzisiaj",
		yesterday: "Wczoraj"
	},
	error: {
		general: "Obecnie nie można wyświetlić powiadomień. Proszę spróbować ponownie później.",
		unauthorized: "Proszę się zalogować, aby zobaczyć powiadomienia."
	},
	info: {
		activateSettings: "Aby otrzymywać powiadomienia, proszę je aktywować w ustawieniach.",
		noNotification: "Obecnie nie ma dla Ciebie żadnych powiadomień."
	},
	title: "Powiadomienia"
};
var results = {
	counter: {
		label: "wyników"
	}
};
var scrollToTop = {
	label: "Przewiń do góry"
};
var slider = {
	nextButton: {
		label: "Następny slajd"
	},
	paginationBullet: {
		label: "Slajd"
	},
	prevButton: {
		label: "Poprzedni slajd"
	}
};
var sorting = {
	ascending: "Rosnąco",
	descending: "Malejąco"
};
var userAccount = {
	address: {
		label: "Adres"
	},
	email: {
		label: "E-mail"
	},
	language: {
		label: "Język",
		locale: "Ustawienia regionalne",
		select: "Wybierz język",
		settings: "Ustawienia językowe"
	},
	loggedOut: {
		message: "Nie jesteś zalogowany"
	},
	login: {
		button: "Zaloguj się"
	},
	name: {
		label: "Imię i nazwisko"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtruj maszyny",
			label: "Maszyny",
			option: {
				all: "Wszystkie maszyny"
			},
			select: "Wybierz maszynę"
		},
		period: {
			label: "Okres",
			option: {
				currentMonth: "Bieżący miesiąc",
				currentWeek: "Bieżący tydzień",
				lastMonth: "Poprzedni miesiąc",
				lastWeek: "Poprzedni tydzień",
				today: "Dzisiaj",
				yesterday: "Wczoraj"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Moje widgety"
	},
	noDescriptionAvailable: "Brak dostępnego opisu.",
	widget: {
		SampleMyMachines: {
			title: "Moje maszyny"
		},
		SampleMyServiceCalls: {
			title: "Przypadki serwisowe"
		},
		SampleMyTrackingList: {
			title: "Status dostawy"
		},
		SampleMyUserAccount: {
			title: "Mój profil"
		},
		SampleOperationalStatesChart: {
			title: "Stany operacyjne"
		},
		SampleWidgetFilter: {
			title: " Ustawienia filtrów"
		},
		SampleWorkloadBalanceChart: {
			title: "Obciążenie"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
